import React from 'react';
import { Card, CardContent, Stack, Box, Typography, Tooltip } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const NavigationCard = ({ title, icon, value, onClick, iconColor = 'primary', tooltip = true }) => {
  const cardContent = (
    <Card
      sx={{
        cursor: 'pointer',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'relative',
        overflow: 'hidden',
        borderRadius: 2,
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: (theme) => `0 12px 40px -12px ${theme.palette.primary.main}40`,
          '& .nav-arrow': {
            opacity: 1,
            transform: 'translateX(0)',
          },
          '& .card-content': {
            backgroundColor: (theme) => theme.palette.action.hover,
          },
          '& .main-icon': {
            transform: 'scale(1.1)',
          },
        },
        '&:active': {
          transform: 'translateY(-4px)',
        },
        '&:focus-visible': {
          outline: `2px solid ${(theme) => theme.palette.primary.main}`,
          outlineOffset: '2px',
        },
      }}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
      tabIndex={0}
      role="button"
      aria-label={`Navigate to ${title.toLowerCase()} page`}
    >
      <CardContent
        className="card-content"
        sx={{
          position: 'relative',
          transition: 'background-color 0.3s ease',
        }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="subtitle1"
              gutterBottom
              sx={{
                fontWeight: 600,
                color: 'text.primary',
              }}
            >
              {title}
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box
                className="main-icon"
                sx={{
                  transition: 'transform 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {React.cloneElement(icon, {
                  color: iconColor,
                  sx: { fontSize: '1.5rem' },
                })}
              </Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: 'text.primary',
                }}
              >
                {value}
              </Typography>
            </Stack>
          </Box>
          <ArrowForwardIosIcon
            className="nav-arrow"
            sx={{
              opacity: 0,
              transform: 'translateX(15px)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              color: 'primary.main',
              fontSize: '1rem',
            }}
          />
        </Stack>
      </CardContent>
    </Card>
  );

  if (tooltip) {
    return (
      <Tooltip title={`Click to view ${title.toLowerCase()}`} arrow placement="top">
        {cardContent}
      </Tooltip>
    );
  }

  return cardContent;
};

export default NavigationCard;
